import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import { IMaskInput } from "react-imask";
import {Card, Form, Button, Row, Col, Table, Dropdown, Spinner} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaEye, FaEraser, FaExclamationTriangle } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, formataDataHoraExibicao, getCurrentUser, origemReceptivo, formataDataExibicao } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';
import ExportPDF from "./ExportPDF";
import ExportCSVExcel from "./ExportCSVExcel";
import moment from "moment-timezone";

class AtendimentosGeral extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onChangeBuscaCPF = this.onChangeBuscaCPF.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaRegistro = this.buscaRegistro.bind(this);
        this.limpaFiltro = this.limpaFiltro.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            busca_cpf: "",
            busca_status_id: '',
            busca_status_nome: "",
            atendente_id: "",
            beneficiario_id: "",
            cliente_id: "",
            etapa_id: "",
            programa_id: "",
            paciente_id: "",
            beneficiario_nome: "",
            data_de: '',
            data_ate: '',
            page_numb: 1,
            loading: true,
            filtro_status: "todos",
            searchTimeout: null,
        };
    }

    componentWillUnmount() {
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }
    }

    componentDidMount() {
        const searchParams = new URLSearchParams(this.props.router.location.search);
        const status = searchParams.get("status");
        const indicador = searchParams.get('indicador') || '';
    
        if (status) {
            this.setState(
                { busca_status_id: status, loading: true, filtro_status: indicador || "todos" },
                () => this.consultaRegistro(this.state.busca, this.state.busca_cpf, 1) 
            );
        } else {
            this.setState(
                { loading: true, filtro_status: indicador || "todos" },
                () => this.consultaRegistro(this.state.busca, this.state.busca_cpf)
            );
            
        }
    }

    async consultaRegistro(busca, busca_cpf, num_page){
        let dados_usuario = getCurrentUser();

        let url = `/atendimentos/?tipo_atendimento=receptivo&tipo_usuario=${dados_usuario['tipo_usuario']}`;

        if(dados_usuario['ambiente_cliente_id']){
            url += `&cliente_id=${dados_usuario['ambiente_cliente_id']}&programa_id=${dados_usuario['ambiente_programa_id']}`;
        }

        //busca
        if(this.state.busca){
            url += `&receptivo_nome=${busca}`;
        }

        if(this.state.busca_cpf){
            url += `&receptivo_cpf=${busca_cpf}`;
        }

        if (this.state.data_de) {
            url += '&data_de=' + this.state.data_de + ' 00:00:00';
        }

        if (this.state.data_ate) {
            url += '&data_ate=' + this.state.data_ate + ' 23:59:59';
        }

        if(this.state.busca_status_id){
            url += `&programa_status_id=${this.state.busca_status_id}`;
        }

        if(this.state.filtro_status) {
            url += `&situacao_atendimento=${this.state.filtro_status}`;
        }

        if(num_page) {
            url += `&page=${num_page}`;
        }

        api.get(url)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar atendimentos, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    renderRows = () => {
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                <td data-label="ID">{item.id}</td>
                <td data-label="Nome">{item.receptivo_nome}<p className="small mb-0">{origemReceptivo[item.receptivo_para_quem]}</p></td>
                <td data-label="Data">{formataDataHoraExibicao(item.data)}</td>
                <td data-label="Status">{item.dados_programa_status.nome || '-'}</td>
                <td data-label="Programa">{item.dados_programa.nome}</td>
                <td data-label="Proxíma Ação" >
                    {item.proxima_acao && item.proxima_acao.data_acao ? (
                        <>
                            {`${formataDataExibicao(item.proxima_acao.data_acao)} ${
                                item.proxima_acao.hora_acao.split('.')[0].slice(0,5)
                            }`}
                            {(() => {
                                const currentDate = moment().tz("America/Sao_Paulo");
                                const actionDate = moment
                                    .tz(item.proxima_acao.data_acao, "America/Sao_Paulo")
                                    .startOf("day");
                                
                                if (actionDate.isSame(currentDate, "day")) {
                                    return <FaExclamationTriangle className="text-warning ms-1" />;
                                } else if (actionDate.isBefore(currentDate, "day")) {
                                    return <FaExclamationTriangle className="text-danger ms-1" />;
                                }
                                return null;
                            })()}
                        </>
                    ) : (
                        <>
                            -
                        </>
                    )}
                </td>
                <td>
                    <Button variant="light" href={"/atendimentos-receptivo/edit/"+item.uuid} size="sm">
                        <FaEye /> Visualizar
                    </Button>                    
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={8}>Nenhum atendimento encontrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        const value = e.target.value;
        this.setState({ busca: value });

        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }

        const newTimeout = setTimeout(() => {
            this.setState({ loading: true, page_numb: 1 });
            this.consultaRegistro(value, this.state.busca_cpf, 1);
        }, 500);

        this.setState({ searchTimeout: newTimeout });
    }

    onChangeBuscaCPF(e) {
        this.setState({
            busca_cpf: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistro(this.state.busca, this.state.busca_cpf, num_page)
    };

    buscaRegistro(e) {
        e.preventDefault();

        this.setState({
            loading: true,
            page_numb: 1
        });
        
        this.consultaRegistro(this.state.busca, this.state.busca_cpf, 1)
    };

    carregaStatusPrograma = async (inputValue) => {
        const dados_usuario = getCurrentUser();
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : '';

        if(!programa_id) {
            return [];
        }

        try {
            const response = await api.get(`/programas/status/?nome=${inputValue}&programa_id=${programa_id}&status=1`);
            const opcoes = response.data.results.map(status => ({
                value: status.id,
                label: status.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar status do programa:', error);
            return [];
        }
    };

    handleChangeFiltros = (event, fieldName) => {
        if (fieldName === 'status_id') {
            this.setState({
                busca_status_id: event.value,
                busca_status_nome: event.label
            });
        } else {
            const { name, value } = event.target;
            this.setState({
                [name]: value
            });
        }
    };

    limpaFiltro() {
        this.setState({
            busca: '',
            busca_cpf: '',
            data_de: '',
            data_ate: '',
        }, () => {
            this.consultaRegistro();
        });
    }

    render() {
        if (!hasPerm('view_atendimentos')) {
            return <Navigate to='/sem-permissao' />
        }

        if (this.state.loading) {
            return (
                <div className="text-center mt-5">
                    <Spinner animation="border" style={{ color: '#fff' }} />
                </div>
            );
        }

        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Atendimentos Receptivos</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        {hasPerm('add_atendimentos') && (
                            <Button variant="secondary" href="/atendimentos-receptivo/add" className="mb-3" size="sm">
                                <FaPlus /> Adicionar Atendimento
                            </Button>
                        )}
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <ExportCSVExcel />
                                <ExportPDF />
                                {!this.state.paciente_id && (
                                    <Dropdown className="d-inline">
                                        <Dropdown.Toggle variant="light" size="sm">
                                            <FaFilter /> Filtrar
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <div className="drop-filter">
                                                <Form method="get" onSubmit={this.buscaRegistro}>
                                                    <Row>
                                                        <Col sm={12} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Nome</Form.Label>                                  
                                                                <Form.Control
                                                                    type="text"
                                                                    name="busca"
                                                                    value={this.state.busca}
                                                                    onChange={this.onChangeBusca}
                                                                    placeholder="Nome do contato"
                                                                    aria-label="Nome do contato"
                                                                    aria-describedby="basic-addon2"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={12} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>CPF</Form.Label>                                  
                                                                <Form.Control
                                                                    as={IMaskInput}
                                                                    mask="000.000.000-00"
                                                                    name="busca_cpf"
                                                                    value={this.state.busca_cpf}
                                                                    onChange={this.onChangeBuscaCPF}
                                                                    placeholder="CPF do contato"
                                                                    aria-label="CPF do contato"
                                                                    aria-describedby="basic-addon2"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                         <Col sm={12} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Data De</Form.Label>
                                                                <Form.Control
                                                                    type="date"
                                                                    name="data_de"
                                                                    value={this.state.data_de}
                                                                    onChange={e => this.handleChangeFiltros(e, 'data_de')}

                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                            <Col sm={12} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Data Até</Form.Label>
                                                                    <Form.Control
                                                                        type="date"
                                                                        name="data_ate"
                                                                        value={this.state.data_ate}
                                                                        onChange={e => this.handleChangeFiltros(e, 'data_ate')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        {dados_usuario['ambiente_programa_id'] && (
                                                        <Col sm={12} xs={12}> 
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Status</Form.Label>
                                                                <AsyncSelect                                 
                                                                    cacheOptions
                                                                    loadOptions={this.carregaStatusPrograma}
                                                                    defaultOptions
                                                                    name="busca_status_id"
                                                                    placeholder="Status"
                                                                    noOptionsMessage={() => "Nenhum status encontrado"}
                                                                    onChange={e => this.handleChangeFiltros(e, 'status_id')}
                                                                    value={this.state.busca_status_id ? { value: this.state.busca_status_id, label: this.state.busca_status_nome } : null}
                                                                    styles={{
                                                                        option: (provided) => ({
                                                                          ...provided,
                                                                          fontSize: '12px', // Ajusta o tamanho da fonte dos resultados
                                                                        }),
                                                                    }}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        )}
                                                    </Row>

                                                    <Button type="submit" variant="light" size="sm">
                                                        <FaSearch /> Filtrar
                                                    </Button>

                                                    <Button type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                                        <FaEraser /> Limpar Filtro
                                                    </Button>
                                                </Form>
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                )}
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Data</th>
                                    <th>Status</th>
                                    <th>Programa</th>
                                    <th>Proxíma Ação</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={7}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={7}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(AtendimentosGeral);
